import { render, staticRenderFns } from "./a-edit-test-popup.vue?vue&type=template&id=0bbd401d&scoped=true"
import script from "./a-edit-test-popup.vue?vue&type=script&lang=js"
export * from "./a-edit-test-popup.vue?vue&type=script&lang=js"
import style0 from "./a-edit-test-popup.vue?vue&type=style&index=0&id=0bbd401d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd401d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbd401d')) {
      api.createRecord('0bbd401d', component.options)
    } else {
      api.reload('0bbd401d', component.options)
    }
    module.hot.accept("./a-edit-test-popup.vue?vue&type=template&id=0bbd401d&scoped=true", function () {
      api.rerender('0bbd401d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/maudiences/views/popups/a-edit-test-popup.vue"
export default component.exports